export const ROLE_LABELS = { cashier: "Cashier", manager: "Manager", admin: "Admin", owner: "Owner" };
export function roleLabel(employee) {
  if (!employee) return "";
  if (employee.is_technician || employee.id === "technician") return "Tech Support";
  return ROLE_LABELS[employee.role] || employee.role || "";
}
